import tt from '@/i18n/utils/translateText';
import QueueSvg from '@/assets/svg/16x16/queue.svg';
import MenuSvg from '@/assets/svg/16x16/menu.svg';

export enum EDigitalQueuePageType {
  booking = 'booking',
  schedule = 'schedule',
}

export enum EDigitalQueuePageView {
  grid = 'grid',
  table = 'table',
}

export enum EDigitalQueueSchedulePageTab {
  timeSlots = 'timeSlots',
  scheduleTemplates = 'scheduleTemplates',
}

export enum EScheduleTemplatesTab {
  setupTimeSlots = 'setupTimeSlots',
  reservationsAndLocks = 'reservationsAndLocks',
}

export enum ECopyModeTab {
  weeklyScheduleTemplate = 'weeklyScheduleTemplate',
  weeklySchedule = 'weeklySchedule',
}

export enum EReservedSlotType {
  booking = 'booking',
  reservation = 'reservation',
  locking = 'locking',
}

export enum ETimeSlotActionType {
  booking = 'booking',
  reservation = 'reservation',
  locking = 'locking',
}

export enum EDigitalQueueDatePickerContext {
  grid = 'grid',
  table = 'table',
  schedule = 'schedule',
}

export enum EScheduleAllowedTargets {
  run = 'run',
  shipment = 'shipment',
  runAndShipment = 'runAndShipment',
}

export const DIGITAL_QUEUE_VIEW_FILTER_SECTION = 'digitalQueueView';
export const DIGITAL_QUEUE_VIEW_BOOKINGS_TABLE_SUBSECTION = 'bookingsTable';

export enum EActionType {
  loading = 'loading',
  unloading = 'unloading',
  loadingAndUnloading = 'loadingAndUnloading',
}

export const ACTION_TYPE_TRANSLATION = {
  [EActionType.loading]: tt('shared.loading'),
  [EActionType.unloading]: tt('shared.unloading'),
  [EActionType.loadingAndUnloading]: tt('shared.loadingAndUnloading'),
};

export const ALLOWED_TARGETS_TRANSLATION = {
  [EScheduleAllowedTargets.run]: tt('shared.runs.declensions', { param: { n: 1 } }),
  [EScheduleAllowedTargets.shipment]: tt('shared.shipment'),
  [EScheduleAllowedTargets.runAndShipment]: tt('shared.runAndShipment'),
};

export enum EDigitalQueuePeriod {
  day = 'day',
  week = 'week',
}

export const digitalQueuePageViewFilters = [
  {
    key: EDigitalQueuePageView.grid,
    label: '',
    icon: QueueSvg,
  },
  {
    key: EDigitalQueuePageView.table,
    label: '',
    icon: MenuSvg,
  },
];

export enum EDigitalQueueLimitType {
  fromCreation = 'from_creation',
  beforeStart = 'before_start',
}

export enum ELockingDurationLimitType {
  beforeStart = 'before_start',
  always = 'always',
}

export enum EDigitalQueueBookingWithOrderFormFields {
  gateId = 'gateId',
  dateTime = 'dateTime',
  freightRequestIid = 'freightRequestIid',
  referenceNumber = 'referenceNumber',
  transitPointId = 'transitPointId',
  timeslots = 'timeslots',
  comment = 'comment',
}

export enum EDigitalQueueBookingWithShipmentFormFields {
  shipmentIid = 'shipmentIid',
  address = 'address',
  customer = 'customer',
}

export enum EDigitalQueueBookingWithoutOrderFormFields {
  comment = 'comment',
  driver = 'driver',
  powerOfAttorney = 'powerOfAttorney',
  truck = 'truck',
  trailer = 'trailer',
  bookingDocuments = 'bookingDocuments',
}

export enum EBookingWorkflowStateSlug {
  registered = 'registered', // Запланировано
  registrationIsNotCompleted = 'registration_is_not_completed', // Зарезервировано
}

// условный круглосуточный режим работы (так как в датапикере нельзя выбрать 24:00)
export const ROUND_THE_CLOCK_TIME = '23:59';

export enum EFormCollapsedFields {
  bookingTimeRestriction = 'bookingTimeRestriction',
  revocationTimeRestriction = 'revocationTimeRestriction',
  rebookingTimeRestriction = 'rebookingTimeRestriction',
  revocationShipmentsTimeRestriction = 'revocationShipmentsTimeRestriction',
  rebookingShipmentsTimeRestriction = 'rebookingShipmentsTimeRestriction',
  reservationsTimeRestriction = 'reservationsTimeRestriction',
}

export enum EBookingSettingsTabs {
  run = 'run',
  shipment = 'shipment',
}

export enum EBookingType {
  withOrder = 'withOrder',
  withoutOrder = 'withoutOrder',
  withShipment = 'withShipment', // создание резервирования под самовывоз
  withShipmentResources = 'withShipmentResources', // заполнение ресурсов для самовывоза (бронирование под самовывоз)
}

export enum EBookingFormPanel {
  driverForm = 'driverForm',
  powerOfAttorneyForm = 'powerOfAttorneyForm',
  truckForm = 'truckForm',
  trailerForm = 'trailerForm',
}

export enum EDigitalQueueTargetType {
  run = 'run', // рейс
  shipment = 'shipment', // самовывоз
  manual = 'manual', // создан вручную ГВ за ГП
  executionRequest = 'execution_request', // резервирования
}

export enum EBookingAuditEvent {
  /** Информация о бронировании отредактирована */
  bookingDriverInfoChanged = 'contractors_context.booking_driver_info_changed',
  /** Отредактирован комментарий к бронированию */
  bookingCommentChanged = 'contractors_context.booking_comment_changed',
  /** Бронирование создано */
  timeSlotBooked = 'contractors_context.time_slot_booked',
  /** Резервирование создано */
  timeSlotReserved = 'contractors_context.time_slot_reserved',
  /** Бронирование перебронировано */
  bookingTimeSlotChanged = 'contractors_context.booking_time_slot_changed',
  /** Резервирование перебронировано */
  reservationTimeSlotChanged = 'contractors_context.reservation_time_slot_changed',
  /** Изменен статус бронирования */
  bookingWorkflowStateChanged = 'contractors_context.booking_workflow_state_changed',
  /** Изменен статус бронирования */
  bookingWorkflowStateRolledBack = 'contractors_context.booking_workflow_state_rolled_back',
  /** Бронирование аннулировано грузовладельцем */
  bookingAnnulled = 'contractors_context.booking_annulled',
  /** Резервирование аннулировано грузовладельцем */
  reservationAnnulled = 'contractors_context.reservation_annulled',
  /** Бронирование аннулировано(отозвано) грузоперевозчиком */
  bookingRevoked = 'contractors_context.booking_revoked',
  /** Резервирование аннулировано(отозвано) грузоперевозчиком */
  reservationRevoked = 'contractors_context.reservation_revoked',
  /** Резервирование отредактировано */
  reservationReassigned = 'contractors_context.reservation_reassigned',
  /** Бронирование отредактировано */
  bookingReassigned = 'contractors_context.booking_reassigned',
  /** Бронирование под самовывоз отредактировано */
  bookingReassignedForShipment = 'contractors_context.booking_reassigned_for_shipment',
  /** Кастомный атрибут изменен */
  customAttributeChanged = 'references_context.custom_attribute_changed',
}

export const BOOKING_AUDIT_EVENT_TRANSLATIONS = {
  [EBookingAuditEvent.timeSlotReserved]: tt('bookingAuditEvent.timeSlotReserved'),
  [EBookingAuditEvent.reservationReassigned]: tt('bookingAuditEvent.reservationReassigned'),
  [EBookingAuditEvent.bookingReassigned]: tt('bookingAuditEvent.bookingDriverInfoChanged'),
  [EBookingAuditEvent.bookingReassignedForShipment]: tt('bookingAuditEvent.bookingDriverInfoChanged'),
  [EBookingAuditEvent.reservationTimeSlotChanged]: tt('bookingAuditEvent.reservationTimeSlotChanged'),
  [EBookingAuditEvent.timeSlotBooked]: tt('shared.timeSlotBooked'),
  [EBookingAuditEvent.bookingAnnulled]: tt('shared.bookingAnnulled'),
  [EBookingAuditEvent.reservationAnnulled]: tt('bookingAuditEvent.reservationAnnulled'),
  [EBookingAuditEvent.bookingDriverInfoChanged]: tt('bookingAuditEvent.bookingDriverInfoChanged'),
  [EBookingAuditEvent.bookingTimeSlotChanged]: tt('bookingAuditEvent.bookingTimeSlotChanged'),
  [EBookingAuditEvent.bookingWorkflowStateChanged]: tt('bookingAuditEvent.bookingWorkflowStateChanged'),
  [EBookingAuditEvent.bookingWorkflowStateRolledBack]: tt('bookingAuditEvent.bookingWorkflowStateChanged'),
  [EBookingAuditEvent.customAttributeChanged]: tt('bookingAuditEvent.customAttributeChanged'),
};

export enum EBookingAuditLogKey {
  referenceNumber = 'referenceNumber',
  transitPointAction = 'transitPointAction',
  address = 'address',
  workflowState = 'workflowState',
  happenedAt = 'happenedAt',
  comment = 'comment',
  powerOfAttorneyNumber = 'powerOfAttorneyNumber',
  powerOfAttorneyIssuedOn = 'powerOfAttorneyIssuedOn',
  powerOfAttorneyInfo = 'powerOfAttorneyInfo',
  gateName = 'gateName',
  fullName = 'fullName',
  birthday = 'birthday',
  birthplace = 'birthplace',
  passportNumber = 'passportNumber',
  passportIssuedOn = 'passportIssuedOn',
  passportIssuedBy = 'passportIssuedBy',
  passportDetails = 'passportDetails',
  registrationAddress = 'registrationAddress',
  phone = 'phone',
  inn = 'inn',
  truckLicensePlate = 'truckLicensePlate',
  truckBrand = 'truckBrand',
  truckOwnership = 'truckOwnership',
  truckForwarderExecutor = 'truckForwarderExecutor',
  truckForwarderExecutorInn = 'truckForwarderExecutorInn',
  truckForwarderContract = 'truckForwarderContract',
  truckForwarderContractIssuedOn = 'truckForwarderContractIssuedOn',
  truckOwnershipDocument = 'truckOwnershipDocument',
  trailerLicensePlate = 'trailerLicensePlate',
  trailerBrand = 'trailerBrand',
  trailerOwnership = 'trailerOwnership',
  trailerOwnershipDocument = 'trailerOwnershipDocument',
  trailerForwarderExecutor = 'trailerForwarderExecutor',
  trailerForwarderExecutorInn = 'trailerForwarderExecutorInn',
  trailerForwarderContract = 'trailerForwarderContract',
  trailerForwarderContractIssuedOn = 'trailerForwarderContractIssuedOn',
}

export const BOOKING_AUDIT_LOG_KEY_TRANSLATIONS = {
  [EBookingAuditLogKey.referenceNumber]: tt('shared.referenceNumber'),
  [EBookingAuditLogKey.transitPointAction]: tt('digitalQueues.showBookingDrawer.auditEvents.transitPointAction'),
  [EBookingAuditLogKey.address]: tt('approvals.shared.routeAddress'),
  [EBookingAuditLogKey.gateName]: tt('digitalQueues.shared.gateName'),
  [EBookingAuditLogKey.workflowState]: tt('digitalQueues.showBookingDrawer.auditEvents.workflowState'),
  [EBookingAuditLogKey.happenedAt]: tt('digitalQueues.showBookingDrawer.auditEvents.happenedAt'),
  [EBookingAuditLogKey.comment]: tt('shared.comment'),
  [EBookingAuditLogKey.powerOfAttorneyNumber]: tt('shared.powerOfAttorneyNumber'),
  [EBookingAuditLogKey.powerOfAttorneyIssuedOn]: tt('shared.powerOfAttorneyDate'),
  [EBookingAuditLogKey.powerOfAttorneyInfo]: tt('shared.powerOfAttorneyDetails'),
  [EBookingAuditLogKey.fullName]: tt('digitalQueues.driverForm.label.fullName'),
  [EBookingAuditLogKey.birthday]: tt('shared.birthday'),
  [EBookingAuditLogKey.birthplace]: tt('shared.birthplace'),
  [EBookingAuditLogKey.passportNumber]: tt('shared.passport'),
  [EBookingAuditLogKey.passportIssuedOn]: tt('shared.passportIssuedOn'),
  [EBookingAuditLogKey.passportIssuedBy]: tt('shared.passportIssuedBy'),
  [EBookingAuditLogKey.registrationAddress]: tt('shared.registrationAddress'),
  [EBookingAuditLogKey.phone]: tt('shared.phone'),
  [EBookingAuditLogKey.inn]: tt('shared.inn'),
  [EBookingAuditLogKey.truckLicensePlate]: tt('freightExecution.executionRequests.runInfo.truck.truckLicensePlate'),
  [EBookingAuditLogKey.truckBrand]: tt('freightExecution.executionRequests.runInfo.truck.truckBrand'),
  [EBookingAuditLogKey.truckOwnership]: tt('freightExecution.executionRequests.runInfo.truck.truckOwnership'),
  [EBookingAuditLogKey.truckOwnershipDocument]: tt('freightExecution.executionRequests.runInfo.truck.truckOwnershipDocument'),
  [EBookingAuditLogKey.truckForwarderExecutor]: tt('shared.executorName'),
  [EBookingAuditLogKey.truckForwarderExecutorInn]: tt('shared.executorInn'),
  [EBookingAuditLogKey.truckForwarderContract]: tt('shared.contractNumber'),
  [EBookingAuditLogKey.truckForwarderContractIssuedOn]: tt('shared.contractSignedOnDate'),
  [EBookingAuditLogKey.trailerLicensePlate]: tt('freightExecution.executionRequests.runInfo.truck.trailerLicensePlate'),
  [EBookingAuditLogKey.trailerBrand]: tt('freightExecution.executionRequests.runInfo.truck.trailerBrand'),
  [EBookingAuditLogKey.trailerOwnership]: tt('freightExecution.executionRequests.runInfo.truck.trailerBrand'),
  [EBookingAuditLogKey.trailerOwnershipDocument]: tt('freightExecution.executionRequests.runInfo.truck.trailerOwnershipDocument'),
  [EBookingAuditLogKey.trailerForwarderExecutor]: tt('shared.executorName'),
  [EBookingAuditLogKey.trailerForwarderExecutorInn]: tt('shared.executorInn'),
  [EBookingAuditLogKey.trailerForwarderContract]: tt('shared.contractNumber'),
  [EBookingAuditLogKey.trailerForwarderContractIssuedOn]: tt('shared.contractSignedOnDate'),
};

export enum EBookingTarget {
  run = 'run',
  selfDelivery = 'self_delivery',
  manual = 'manual',
}

export enum EBookingState {
  detached = 'detached',
  inProgress = 'in_progress',
  done = 'done',
  lateArrival = 'late_arrival',
  lateDeparture = 'late_departure',
  reserved = 'reserved',
}

export enum EBookingStatusState {
  done = 'done', // Работа завершена
  inProgress = 'in_progress', // В процессе
  booked = 'booked', // Запланировано
  registrationIsNotCompleted = 'registration_is_not_completed', // Ожидает внесения данных (Резервирование)
  annulled = 'annulled', // Аннулировано
  registered = 'registered', // Зарегистрировано(бронь ГВ за ГП в ЦО)
  locked = 'locked', // Заблокировано
  reserved = 'reserved', // Зарезервировано
}

export const BOOKING_STATE_LATE_STATUS_TRANSLATION = {
  [EBookingState.lateArrival]: tt('digitalQueues.shared.lateArrival'),
  [EBookingState.lateDeparture]: tt('digitalQueues.shared.lateDeparture'),
};

export enum EBookingOwnership {
  own = 'own',
  spouses = 'spouses',
  rent = 'rent',
  leasing = 'leasing',
  freeUsage = 'free_usage',
}

export const BOOKING_OWNERSHIP_TRANSLATION = {
  [EBookingOwnership.own]: tt('shared.own'),
  [EBookingOwnership.spouses]: tt('shared.spouses'),
  [EBookingOwnership.rent]: tt('shared.rent'),
  [EBookingOwnership.leasing]: tt('shared.leasing'),
  [EBookingOwnership.freeUsage]: tt('shared.freeUsage'),
};
